import React, { useCallback, useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import { Icon } from '@lomarengas/design-system';
import {
  ActionButtons,
  addStatusToast,
  Loader,
  SectionHeader,
} from '../../common/components';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { LOADING_STATUS } from '../../common/constants';
import {
  AccommodationAttributeQueryFilters,
  getAllAccommodationAttributesAsync,
  selectAccommodationAttributes,
  selectAccommodationAttributesLoadingStatus,
  getAccommodationAttributeOptionsAsync,
  AccommodationAttributeDetailsTranslations,
  AccommodationAttributeDetailsData,
  getAccommodationAttributeDetailsAsync,
  getAttributesTypesAsync,
  clearAccommodationAttributeDetails,
  selectAccommodationAttributeDetails,
  selectAccommodationAttributeDetailsLoadingStatus,
  selectAccommodationAttributeOptions,
  selectAttributeTypes,
  selectAttributeTypesLoadingStatus,
  updateAccommodationAttributeAsync,
  AccommodationAttributeOptionItem,
} from './accommodationAttributesSlice';
import { AccommodationAttributeItem } from './accommodationsSlice';

function AccommodationAttributeDetails() {
  const backLinkUrl = '/accommodations/accommodationattributes';
  const params = useParams();
  const history = useNavigate();
  const [editedOption, setEditedOption] =
    useState<AccommodationAttributeOptionItem>({
      id: '',
      nameFi: '',
      nameEn: '',
      nameRu: '',
      index: null,
    });
  const dispatch = useAppDispatch();
  const accommodationAttributeDetails = useAppSelector(
    selectAccommodationAttributeDetails,
  );
  const attributeTypes = useAppSelector(selectAttributeTypes);
  const attributeTypesLoadingStatus = useAppSelector(
    selectAttributeTypesLoadingStatus,
  );
  const accommodationAttributeOptions = useAppSelector(
    selectAccommodationAttributeOptions,
  );
  const [accommodationAttributeTemp, setAccommodationAttribute] = useState(
    accommodationAttributeDetails,
  );
  const [attributeOptionsTemp, setattributeOptionsTemp] = useState(
    accommodationAttributeOptions,
  );
  const accommodationAttributeDetailsLoadingStatus = useAppSelector(
    selectAccommodationAttributeDetailsLoadingStatus,
  );
  const HandleOptioneItemReorder = (OldNumber: number, NewNumber: number) => {
    const attributeItem = attributeOptionsTemp[OldNumber];
    const reorderedAttributeList: AccommodationAttributeOptionItem[] = [];
    if (NewNumber < 0) {
      NewNumber = 0;
    }
    if (OldNumber < NewNumber) {
      attributeOptionsTemp.forEach((item, index) => {
        if (index < OldNumber) {
          const itemset = { ...item, index };
          reorderedAttributeList.push(itemset);
        } else if (index === NewNumber) {
          const itemset = { ...item, index: item.index - 1 };
          const imageItemset = {
            ...attributeItem,
            index: attributeItem.index + 1,
          };
          reorderedAttributeList.push(itemset);
          reorderedAttributeList.push(imageItemset);
        } else if (index !== OldNumber) {
          const itemset = { ...item, index };
          reorderedAttributeList.push(itemset);
        }
      });
    } else {
      attributeOptionsTemp.forEach((item, index) => {
        if (index < NewNumber) {
          const itemset = { ...item, index };
          reorderedAttributeList.push(itemset);
        } else if (index === NewNumber) {
          const itemset = { ...item, index: item.index + 1 };
          const imageItemset = {
            ...attributeItem,
            index: attributeItem.index - 1,
          };
          reorderedAttributeList.push(imageItemset);
          reorderedAttributeList.push(itemset);
        } else if (index !== OldNumber) {
          const itemset = { ...item, index };
          reorderedAttributeList.push(itemset);
        }
      });
    }
    setattributeOptionsTemp(reorderedAttributeList);
  };
  function getItem(locale, keyId, item) {
    if (accommodationAttributeDetailsLoadingStatus === LOADING_STATUS.IDLE) {
      const found = item.translations.filter(
        a => a.locale === locale && a.keyId === keyId,
      );
      if (found && found[0] && found[0].text) {
        return found[0].text;
      }
    }
    return '';
  }
  // generate html elements of listed accommodations
  // calling html element shoud have table element and header elements
  // as this only creates list of records
  const optionSelectsForAttributeType = attributeTypes?.map(item => (
    <option
      key={item.id}
      id={item.id}
      value={item.id}
      className="position-relative"
    >
      {item.nameFi}
    </option>
  ));

  const handleInputChange = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    setAccommodationAttribute({ ...accommodationAttributeTemp, [name]: value });
  };

  const handleAttributeOptionChange = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const option = attributeOptionsTemp?.filter(item => item.id === value)[0];
    setEditedOption(option);
  };

  const handleAttributeInputFocus = (itemId: string) => {
    const option = attributeOptionsTemp?.filter(item => item.id === itemId)[0];
    setEditedOption(option);
  };

  function getSelectedType(id) {
    const items = attributeTypes.filter(item => item.id === id);
    if (items != null && items.length > 0) {
      return items[0];
    }
    return null;
  }
  const handleAttributeTypeChange = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const typeNameItem = getSelectedType(value);

    if (!typeNameItem) {
      return;
    }

    const attributeType = {
      ...accommodationAttributeTemp.attributeType,
      id: value,
      typeName: typeNameItem.typeName,
    };

    const storeAttribute = {
      ...accommodationAttributeTemp,
      attributeType,
    };

    if (
      storeAttribute.attributeType.typeName === 'MultiSelect' &&
      (attributeOptionsTemp == null || attributeOptionsTemp.length === 0)
    ) {
      setEditedOption({
        id: '',
        nameFi: '',
        nameEn: '',
        nameRu: '',
        index: null,
      });
    }
    setAccommodationAttribute(storeAttribute);
  };

  const handleGroupNumberChange = event => {
    const { target } = event;
    const value = parseInt(target.value, 10);
    setAccommodationAttribute({
      ...accommodationAttributeTemp,
      groupNumber: value,
    });
  };

  const editOptionValueFi = (options, value, id) => {
    options = options.map(item => {
      const temp = item;
      if (temp.id === id) {
        const temp2 = { ...temp, nameFi: value };
        setEditedOption(temp2);
        return temp2;
      }
      return item;
    });
    return options;
  };

  const editOptionValueEn = (options, value, id) => {
    options = options.map(item => {
      const temp = item;
      if (temp.id === id) {
        const temp2 = { ...temp, nameEn: value };
        setEditedOption(temp2);
        return temp2;
      }
      return item;
    });
    return options;
  };

  const editOptionValueRu = (options, value, id) => {
    options = options.map(item => {
      const temp = item;
      if (temp.id === id) {
        const temp2 = { ...temp, nameRu: value };
        setEditedOption(temp2);
        return temp2;
      }
      return item;
    });
    return options;
  };

  const editTranslations = (translations, keyId, locale, value) => {
    let exist = false;

    translations = translations.map(item => {
      const temp = item;
      if (temp.keyId === keyId && temp.locale === locale) {
        const temp2 = { ...temp, text: value };
        exist = true;
        return temp2;
      }
      return item;
    });
    if (!exist) {
      const newitem: AccommodationAttributeDetailsTranslations = {
        locale,
        keyId,
        text: value,
      };
      translations = [...translations, newitem];
      return translations;
    }
    return translations;
  };

  const handleInputChangeOptionFi = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { id } = target;
    let optionsTemp = attributeOptionsTemp;
    optionsTemp = editOptionValueFi(optionsTemp, value, id);
    setattributeOptionsTemp(optionsTemp);
  };

  const handleInputChangeOptionRu = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { id } = target;
    let optionsTemp = attributeOptionsTemp;
    optionsTemp = editOptionValueRu(optionsTemp, value, id);
    setattributeOptionsTemp(optionsTemp);
  };

  const handleInputChangeOptionEn = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { id } = target;
    let optionsTemp = attributeOptionsTemp;
    optionsTemp = editOptionValueEn(optionsTemp, value, id);
    setattributeOptionsTemp(optionsTemp);
  };

  const handleInputChangeTranslation = event => {
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { id } = target;
    const { name } = target;
    let translationsTemp = accommodationAttributeTemp.translations;
    if (id.endsWith('FiFi')) {
      translationsTemp = editTranslations(
        translationsTemp,
        name,
        'fi_FI',
        value,
      );
    } else if (id.endsWith('EnEn')) {
      translationsTemp = editTranslations(
        translationsTemp,
        name,
        'en_EN',
        value,
      );
    } else if (id.endsWith('RuRu')) {
      translationsTemp = editTranslations(
        translationsTemp,
        name,
        'ru_RU',
        value,
      );
    }

    const storeAccommodationAttribute = { ...accommodationAttributeTemp };
    storeAccommodationAttribute.translations = translationsTemp;
    setAccommodationAttribute(storeAccommodationAttribute);
  };

  function getUpdateData(tempData) {
    const updateAccommodationAttributeData: AccommodationAttributeDetailsData =
      {
        id: tempData.id,
        isDeleted: false,
        isVisibleInWebShop: tempData.isVisibleInWebShop,
        isVisibleInAccommodation: tempData.isVisibleInAccommodation,
        isSearchCriteria: tempData.isSearchCriteria,
        hasNoValue: tempData.hasNoValue,
        noIcon: tempData.noIcon,
        yesIcon: tempData.yesIcon,
        showIcon: tempData.showIcon,
        groupNumber: tempData.groupNumber,
        attributeType: {
          id: tempData.attributeType.id,
          isDeleted: false,
          typeName: tempData.attributeType.typeName,
          nameFi: tempData.attributeType.nameFi,
          nameEn: tempData.attributeType.nameEn,
          nameRu: tempData.attributeType.nameRu,
        },
        optionItems: attributeOptionsTemp,
        translations: tempData.translations,
      };

    return updateAccommodationAttributeData;
  }

  const addOption = () => {
    let tempOptions = attributeOptionsTemp;
    const newAttributeOption: AccommodationAttributeOptionItem = {
      nameEn: '',
      nameFi: '',
      nameRu: '',
      id: Math.random().toString(),
      index: null,
    };
    tempOptions = [...tempOptions, newAttributeOption];
    setattributeOptionsTemp(tempOptions);
    setEditedOption(newAttributeOption);
  };

  const removeOption = (itemId: string) => {
    const tempOptions = attributeOptionsTemp;
    const newlist = tempOptions.filter(e => e.id !== itemId);
    setattributeOptionsTemp(newlist);
  };
  const updateAttribute = event => {
    const data = getUpdateData(accommodationAttributeTemp);
    dispatch(updateAccommodationAttributeAsync(data)).then(res => {
      if (res.meta.requestStatus === 'fulfilled') {
        dispatch(
          addStatusToast({
            Message: `Attribuutti tallenettu.`,
            Title: 'Ok',
            IsAutohide: true,
          }),
        );
        history('/accommodations/accommodationattributes');
      }
    });
  };
  const [filtering, setFiltering] =
    useState<AccommodationAttributeQueryFilters>({
      pageSize: 200,
      pageNumber: 1,
    });

  const initFetch = useCallback(() => {
    dispatch(
      getAccommodationAttributeDetailsAsync(params.accommodationattributeId),
    );
    dispatch(
      getAccommodationAttributeOptionsAsync(params.accommodationattributeId),
    );
    dispatch(getAttributesTypesAsync(filtering));
    dispatch(getAllAccommodationAttributesAsync(filtering));
  }, [dispatch]);

  useEffect(() => {
    initFetch();
    return () => {
      dispatch(clearAccommodationAttributeDetails());
    };
  }, [initFetch, dispatch]);

  useEffect(() => {
    if (accommodationAttributeDetails) {
      setAccommodationAttribute(accommodationAttributeDetails);
    }
  }, [accommodationAttributeDetails]);

  useEffect(() => {
    if (accommodationAttributeOptions) {
      setattributeOptionsTemp(accommodationAttributeOptions);
    }
  }, [accommodationAttributeOptions]);

  return (
    <>
      <Helmet>
        <title>Varustelu - tiedot</title>
      </Helmet>

      <Container className="container-content">
        <SectionHeader
          BackLink={backLinkUrl}
          Breadcrumbs={['Majoitukset ja Ryhmät', 'Majoitusten varustelut']}
          Title={getItem(
            'fi_FI',
            'AccommodationAttributeName',
            accommodationAttributeTemp,
          )}
        />

        <Loader
          IsLoading={
            accommodationAttributeDetailsLoadingStatus ===
            LOADING_STATUS.LOADING
          }
        />

        {accommodationAttributeDetailsLoadingStatus === LOADING_STATUS.IDLE && (
          <div>
            <Container className="container-form mt-48">
              <Form.Group className="mb-40">
                <Form.Label htmlFor="AccommodationAttributeGroupNumber">
                  Ryhmä:{' '}
                </Form.Label>
                <Form.Select
                  id="AccommodationAttributeGroupNumber"
                  value={accommodationAttributeTemp.groupNumber}
                  onChange={handleGroupNumberChange}
                  name="groupNumber"
                >
                  <option value={0}>Ei valittu</option>
                  <option value={40}>Varustelu</option>
                  <option value={41}>Mökin tiedot</option>
                  <option value={42}>Etäisyydet</option>
                  <option value={43}>Muut</option>
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-40">
                <Form.Label
                  className="required"
                  htmlFor="AccommodationAttributeNameFiFi"
                >
                  Lyhytnimi
                </Form.Label>
                <Form.Control
                  autoComplete="off"
                  id="AccommodationAttributeNameFiFi"
                  required
                  value={getItem(
                    'fi_FI',
                    'AccommodationAttributeName',
                    accommodationAttributeTemp,
                  )}
                  onChange={handleInputChangeTranslation}
                  name="AccommodationAttributeName"
                />
              </Form.Group>

              <Form.Group className="mb-40">
                <Form.Label
                  className="required"
                  htmlFor="AccommodationAttributeNameTranslationFiFi"
                >
                  Kuvaus FI
                </Form.Label>
                <Form.Control
                  autoComplete="off"
                  id="AccommodationAttributeNameFiFi"
                  required
                  value={getItem(
                    'fi_FI',
                    'AccommodationAttributeNameTranslation',
                    accommodationAttributeTemp,
                  )}
                  onChange={handleInputChangeTranslation}
                  name="AccommodationAttributeNameTranslation"
                />
              </Form.Group>

              <Form.Group className="mb-40">
                <Form.Label
                  className="required"
                  htmlFor="AccommodationAttributeNameTranslationEnEn"
                >
                  Kuvaus EN
                </Form.Label>
                <Form.Control
                  autoComplete="off"
                  id="AccommodationAttributeNameTranslationEnEn"
                  required
                  value={getItem(
                    'en_EN',
                    'AccommodationAttributeNameTranslation',
                    accommodationAttributeTemp,
                  )}
                  onChange={handleInputChangeTranslation}
                  name="AccommodationAttributeNameTranslation"
                />
              </Form.Group>

              {/* <Form.Group className="mb-40"> */}
              {/*  <Form.Label */}
              {/*    className="required" */}
              {/*    htmlFor="AccommodationAttributeNameTranslationRuRu" */}
              {/*  > */}
              {/*    Kuvaus RU */}
              {/*  </Form.Label> */}
              {/*  <Form.Control */}
              {/*    autoComplete="off" */}
              {/*    id="AccommodationAttributeNameTranslationRuRu" */}
              {/*    required */}
              {/*    value={getItem( */}
              {/*      'ru_RU', */}
              {/*      'AccommodationAttributeNameTranslation', */}
              {/*      accommodationAttributeTemp, */}
              {/*    )} */}
              {/*    onChange={handleInputChangeTranslation} */}
              {/*    name="AccommodationAttributeNameTranslation" */}
              {/*  /> */}
              {/* </Form.Group> */}

              <Form.Group className="mb-40">
                <Form.Label
                  className="required"
                  htmlFor="accommodationAttributeType"
                >
                  Varustelun tyyppi
                </Form.Label>
                <Form.Select
                  id="accommodationAttributeType"
                  onChange={handleAttributeTypeChange}
                  value={
                    accommodationAttributeTemp.attributeType != null
                      ? accommodationAttributeTemp.attributeType.id
                      : ''
                  }
                >
                  {optionSelectsForAttributeType}
                </Form.Select>
              </Form.Group>

              <Form.Group className="mb-24">
                <Form.Check
                  checked={accommodationAttributeTemp.hasNoValue ?? false}
                  className="mb-24"
                  id="hasNoValue"
                  inline
                  label="Sisältää EI tiedon?"
                  name="hasNoValue"
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>
              {accommodationAttributeTemp.attributeType != null &&
                accommodationAttributeTemp.attributeType.typeName ===
                  'MultiSelect' &&
                editedOption != null && (
                  <>
                    <hr className="hr-light mb-32" />
                    <h3 className="h5 h4-md mb-32">
                      Varustelun valinnan vaihtoehdot
                    </h3>

                    <Button
                      className="mb-32"
                      onClick={addOption}
                      variant="blue"
                    >
                      + Lisää Valinta
                    </Button>

                    {attributeOptionsTemp.length > 0 && (
                      <div className="table-responsive-lg mb-48">
                        <Table borderless>
                          <thead>
                            <tr>
                              <th>Nimi FI</th>
                              <th>Nimi EN</th>
                              {/* <th>Nimi RU</th> */}
                              <th>Järjestys</th>
                              <th>Poista</th>
                            </tr>
                          </thead>
                          <tbody>
                            {attributeOptionsTemp?.map((item, index) => (
                              <tr key={item.id} tabIndex={item.index}>
                                <td>
                                  <Form.Control
                                    id={item.id}
                                    onFocus={() =>
                                      handleAttributeInputFocus(item.id)
                                    }
                                    onChange={handleInputChangeOptionFi}
                                    value={item.nameFi}
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    id={item.id}
                                    onFocus={() =>
                                      handleAttributeInputFocus(item.id)
                                    }
                                    onChange={handleInputChangeOptionEn}
                                    value={item.nameEn}
                                  />
                                </td>
                                <td>
                                  <Form.Control
                                    id={item.id}
                                    onFocus={() =>
                                      handleAttributeInputFocus(item.id)
                                    }
                                    onChange={handleInputChangeOptionRu}
                                    value={item.nameRu}
                                  />
                                </td>
                                <td style={{ width: 130 }}>
                                  <Button
                                    className="border-0 me-8 px-8"
                                    style={{ width: 48 }}
                                    disabled={item.index === 0}
                                    onClick={() =>
                                      HandleOptioneItemReorder(
                                        item.index + 1 - 1,
                                        item.index + 1 - 2,
                                      )
                                    }
                                    title="Siirrä ylös"
                                    variant="outline-blue"
                                  >
                                    <Icon Name="caret-up-fill" />
                                  </Button>
                                  <Button
                                    className="border-0 me-8 px-8"
                                    style={{ width: 48 }}
                                    disabled={
                                      item.index + 1 ===
                                      attributeOptionsTemp.length
                                    }
                                    onClick={() =>
                                      HandleOptioneItemReorder(
                                        item.index + 1 - 1,
                                        item.index + 1,
                                      )
                                    }
                                    title="Siirrä alas"
                                    variant="outline-blue"
                                  >
                                    <Icon Name="caret-down-fill" />
                                  </Button>
                                </td>
                                <td>
                                  <Button
                                    className="p-0"
                                    onClick={() => removeOption(item.id)}
                                    size="sm"
                                    variant="danger"
                                    style={{
                                      height: 48,
                                      width: 48,
                                    }}
                                  >
                                    X
                                  </Button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    )}
                  </>
                )}

              <hr className="hr-light mb-32" />
              <h3 className="h5 h4-md mb-32">Näkyvyydet</h3>

              <Form.Group className="mb-24">
                <Form.Check
                  checked={
                    accommodationAttributeTemp.isVisibleInWebShop ?? false
                  }
                  className="mb-24"
                  id="isVisibleInWebShop"
                  inline
                  label="Näkyy verkkokaupassa?"
                  name="isVisibleInWebShop"
                  onChange={handleInputChange}
                  required
                />
                <Form.Check
                  checked={
                    accommodationAttributeTemp.isVisibleInAccommodation ?? false
                  }
                  className="mb-24"
                  id="isVisibleInAccommodation"
                  inline
                  label="Näkyy mökkikortilla?"
                  name="isVisibleInAccommodation"
                  onChange={handleInputChange}
                  required
                />
                <Form.Check
                  checked={accommodationAttributeTemp.isSearchCriteria ?? false}
                  className="mb-24"
                  id="isSearchCriteria"
                  inline
                  label="Onko hakuehto?"
                  name="isSearchCriteria"
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>

              <hr className="hr-light mb-32" />
              <h3 className="h5 h4-md mb-32">Ikoni</h3>

              <Form.Group className="mb-24">
                <Form.Check
                  checked={accommodationAttributeTemp.showIcon ?? false}
                  className="mb-24"
                  id="showIcon"
                  inline
                  label="Näytetäänkö Ikoni?"
                  name="showIcon"
                  onChange={handleInputChange}
                  required
                />
              </Form.Group>
              <Row xs={1} xl={2}>
                <Col>
                  <Form.Group controlId="yesIcon" className="mb-40">
                    <Form.Label className="required">Ikonin nimi ?</Form.Label>
                    <Form.Control
                      autoComplete="off"
                      required
                      value={accommodationAttributeTemp.yesIcon ?? ''}
                      onChange={handleInputChange}
                      name="yesIcon"
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group controlId="noIcon" className="mb-40">
                    <Form.Label className="required">
                      Ei ikonin nimi ?
                    </Form.Label>
                    <Form.Control
                      autoComplete="off"
                      required
                      value={accommodationAttributeTemp.noIcon ?? ''}
                      onChange={handleInputChange}
                      name="noIcon"
                    />
                  </Form.Group>
                </Col>
              </Row>

              <ActionButtons
                CancelButtonUrl={backLinkUrl}
                HandleSave={updateAttribute}
                DeleteButtonText={null}
                HandleDelete={null}
              />
            </Container>
          </div>
        )}
      </Container>
    </>
  );
}

export default AccommodationAttributeDetails;
